import React from 'react';
import { Shield, Terminal, CheckCircle, AlertTriangle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';

const getCheckIcon = (passed) => (
  passed ? (
    <CheckCircle className="w-4 h-4 text-success" />
  ) : (
    <AlertTriangle className="w-4 h-4 text-destructive" />
  )
);

const ProductionReadinessCard = ({ productionStatus }) => {
  return (
    <Card className="glass-card border-white/20">
      <CardHeader>
        <div className="flex items-center gap-2">
          <Shield className="w-5 h-5 text-primary" />
          <div>
            <CardTitle>Production Readiness</CardTitle>
            <CardDescription className="mt-1">System configuration checks</CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {productionStatus?.readiness_checks && Object.entries(productionStatus.readiness_checks).map(([key, passed]) => (
            <div key={key} className="flex items-center justify-between p-3 rounded-lg bg-secondary/50">
              <span className="text-sm font-medium capitalize">{key.replace(/_/g, ' ')}</span>
              <div className="flex items-center gap-2">
                {getCheckIcon(passed)}
                <span className="text-xs text-muted-foreground">{passed ? 'Passed' : 'Failed'}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-4 p-4 rounded-lg bg-primary/5 border border-primary/20">
          <div className="flex items-center gap-2">
            <Terminal className="w-4 h-4 text-primary" />
            <span className="text-sm font-semibold">Environment Mode:</span>
            <Badge className={productionStatus?.env_mode === 'production' ? 'bg-success/10 text-success' : 'bg-warning/10 text-warning'}>
              {productionStatus?.env_mode || 'Unknown'}
            </Badge>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ProductionReadinessCard;
